import { useEffect, useState } from "react";

// True while the element given to the returned callback ref is on screen; starts true so sticky bars don't flash on load.
export const useInView = () => {
  const [el, setEl] = useState(null);
  const [inView, setInView] = useState(true);
  useEffect(() => {
    if (!el || !("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { rootMargin: "0px 0px -40px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [el]);
  return [setEl, inView];
};
